import { render, staticRenderFns } from "./DefaultPosition.vue?vue&type=template&id=39c41e56"
import script from "./DefaultPosition.vue?vue&type=script&lang=js"
export * from "./DefaultPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports